export default {
	styleOverrides: {
		root: {
			padding: '16px 16px'
		}
	}
};
